import { render, staticRenderFns } from "./IrrigationAnalysis.vue?vue&type=template&id=1c90d544&scoped=true"
import script from "./IrrigationAnalysis.vue?vue&type=script&lang=js"
export * from "./IrrigationAnalysis.vue?vue&type=script&lang=js"
import style0 from "./IrrigationAnalysis.vue?vue&type=style&index=0&id=1c90d544&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c90d544",
  null
  
)

export default component.exports